import { QuestionCategories } from './question-categories';

export interface ScoreModel {
  quadrantName: string;
  categoryName: string;
  categoryType: QuestionCategories;
  score: number;
  index: number;
  hover?: boolean;
  selected?: boolean;
  dirty?: boolean;
}
